module.exports = __webpack_public_path__ + "static/media/chamber.f4e774bd.png";